import { useCallback } from 'react';
import { getLangText } from '@shared/util/textGetters';
import useCurrentLang from './useCurrentLang';

const useLangText = () => {
    const lang = useCurrentLang();

    return useCallback(
        (extraTitle?: Record<string, string> | string | unknown) =>
            getLangText(extraTitle as string, lang, ''),
        [lang],
    );
};

export default useLangText;
